module.exports = __webpack_public_path__ + "static/media/top-nfts-5.047cb519.jpg";